import Input from '../../../@Component/Domain/Multiplayer/Model/Input/Input';

export default function isRequiredField(field: Input): boolean
{
    return field.isRequired();
}
